export default __webpack_public_path__ + "static/media/nav-forward.ea1202e8.svg";